import { cn } from "@/lib/utils";

export type KdsOrderFilter = "all" | "table" | "tab" | "takeout" | "delivery";

interface KdsFilterBarProps {
  activeFilter: KdsOrderFilter;
  onFilterChange: (filter: KdsOrderFilter) => void;
}

const filters: { value: KdsOrderFilter; label: string }[] = [
  { value: "all", label: "Todos" },
  { value: "table", label: "Salão" },
  { value: "tab", label: "Comanda" },
  { value: "takeout", label: "Retirada" },
  { value: "delivery", label: "Delivery" },
];

export function KdsFilterBar({ activeFilter, onFilterChange }: KdsFilterBarProps) {
  return (
    <div className="flex gap-1">
      {filters.map((f) => (
        <button
          key={f.value}
          onClick={() => onFilterChange(f.value)}
          className={cn(
            "px-3 py-1.5 text-xs font-medium rounded-lg transition-colors",
            activeFilter === f.value
              ? "bg-emerald-600 text-white"
              : "bg-zinc-700 text-zinc-400 hover:bg-zinc-600 hover:text-zinc-300"
          )}
        >
          {f.label}
        </button>
      ))}
    </div>
  );
}
